<template>
  <div class="package-order-form">
    <form @submit.prevent>

      <div class="card shadow-sm mb-4">
        <div class="card-header bg-light">
          <h6 class="mb-0 text-primary fw-bold"><i class="fas fa-info-circle me-2"></i>Informacje podstawowe</h6>
        </div>
        <div class="card-body">
          <div class="row g-3">

            <div class="col-md-6">
              <label class="form-label required">Nazwa zamówienia</label>
              <input
                  type="text"
                  :class="orderNameInputClass"
                  v-model="orderName"
                  :disabled="readOnly"
                  placeholder="Wprowadź nazwę zamówienia"
              >
              <div class="invalid-feedback">Nazwa zamówienia jest wymagana</div>
            </div>

            <div v-if="initialPackageOrderData"
                 class="col-md-6">
              <!--              Nie mozna edytować, będzie updatowana automatycznie-->
              <label class="form-label">Numer referencyjny</label>
              <input
                  type="text"
                  class="form-control"
                  v-model="orderReference"
                  :disabled="true"
                  placeholder="Np. numer zewnętrzny"
              >
            </div>

            <div class="col-12">
              <label class="form-label required">Przypisany dostawca</label>
              <div class="input-group">
                <input
                    :value="assignedSupplierValue"
                    type="text"
                    :class="supplierIdInputClass"
                    readonly
                    placeholder="Brak przypisanego dostawcy"
                >
                <button
                    v-if="!readOnly"
                    class="btn btn-outline-primary"
                    type="button"
                    @click="openSupplierAssigningForm"
                    :disabled="orderIsCentral"
                >
                  <i class="fas fa-exchange-alt me-1"></i> Zmień przypisanie
                </button>
                <div class="invalid-feedback">Do rozliczenia należy przypisać dostawcę</div>
              </div>
            </div>

            <div class="col-12">
              <label class="form-label required">Przypisany hurtownik</label>
              <div class="input-group">
                <input
                    :value="assignedWholesalerValue"
                    type="text"
                    :class="wholesalerIdInputClass"
                    readonly
                    placeholder="Brak przypisanego hurtownika"
                >
                <button
                    v-if="!readOnly"
                    class="btn btn-outline-primary"
                    type="button"
                    @click="openWholesalerAssigningForm"
                    :disabled="orderIsCentral"
                >
                  <i class="fas fa-exchange-alt me-1"></i> Zmień przypisanie
                </button>
                <div class="invalid-feedback">Do rozliczenia należy przypisać hurtownika</div>
              </div>
            </div>

            <div class="col-md-6">
              <label class="form-label">Producent</label>
              <input
                  type="text"
                  class="form-control"
                  v-model="producer"
                  :disabled="readOnly"
              >
            </div>

            <div v-if="initialPackageOrderData"
                 class="col-md-6">
              <label class="form-label">Status</label>
              <select
                  class="form-select"
                  v-model="orderStatus"
                  :disabled="readOnly"
              >
                <option
                    v-for="value in Object.values(packagesModule.getPackageOrderStatusMapWithDescription)"
                    :key="value.key"
                    :value="value.key"
                >
                  {{ value.text }}
                </option>
              </select>
            </div>



            <div class="col-md-6">
              <label class="form-label">Data utworzenia</label>
              <input
                  type="datetime-local"
                  class="form-control"
                  v-model="orderCreationDateFormatted"
                  :disabled="readOnly"
              >
            </div>

            <div v-if="initialPackageOrderData" class="col-md-6">
              <label class="form-label">Data realizacji</label>
<!--              Nie mozna edytować, realizacja będzie updatowana automatycznie-->
              <input
                  type="datetime-local"
                  class="form-control"
                  v-model="orderRealisationDateFormatted"
                  :disabled="true"
              >
            </div>

            <div class="col-12">
              <label class="form-label">Notatki / Powiadomienia</label>
              <textarea
                  class="form-control"
                  rows="2"
                  v-model="notifications"
                  :disabled="readOnly"
              ></textarea>
            </div>

          </div>
        </div>
      </div>

      <div v-if="initialPackageOrderData" class="card shadow-sm mb-4">
        <div class="card-header bg-light">
          <h6 class="mb-0 text-success fw-bold"><i class="fas fa-coins me-2"></i>Wartości i Statystyki</h6>
        </div>
        <div class="card-body">
          <div class="row g-3">

            <div class="col-md-3">
              <label class="form-label text-muted small">Wartość Netto</label>
              <div class="input-group">
                <input type="number" class="form-control fw-bold" v-model="orderValueTaxExcluded" readonly>
                <span class="input-group-text">PLN</span>
              </div>
            </div>

            <div class="col-md-3">
              <label class="form-label text-muted small">Wartość Brutto</label>
              <div class="input-group">
                <input type="number" class="form-control fw-bold" v-model="orderValueTaxIncluded" readonly>
                <span class="input-group-text">PLN</span>
              </div>
            </div>

            <div class="col-md-3">
              <label class="form-label text-muted small">Ilość sztuk</label>
              <input type="number" class="form-control" v-model="orderUnitsAmount" readonly>
            </div>

            <div class="col-md-3">
              <label class="form-label text-muted small">Cel dni zapasu</label>
              <input type="number" class="form-control" v-model="targetSupplyDays" :disabled="readOnly">
            </div>

            <div class="col-12">
              <label class="form-label text-muted small">Poziom realizacji</label>
              <div class="progress" style="height: 20px;">
                <div
                    class="progress-bar bg-success"
                    role="progressbar"
                    :style="{width: (realisationLevel * 100) + '%'}"
                    :aria-valuenow="realisationLevel * 100"
                    aria-valuemin="0"
                    aria-valuemax="100">
                  {{ (realisationLevel * 100).toFixed(1) }}%
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="card shadow-sm mb-4">
        <div class="card-header bg-light">
          <h6 class="mb-0 text-secondary fw-bold"><i class="fas fa-cogs me-2"></i>Konfiguracja</h6>
        </div>
        <div class="card-body">
          <div class="row g-3">

            <div class="col-md-3">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" v-model="orderToDivide" :disabled="readOnly">
                <label class="form-check-label">Do podziału</label>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" v-model="doCreateProspect" :disabled="readOnly">
                <label class="form-check-label">Utwórz Prospekt</label>
              </div>
            </div>

            <div v-if="initialPackageOrderData" class="col-md-3">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" :checked="orderIsCentral" disabled>
                <label class="form-check-label">Zamówienie Centralne</label>
              </div>
            </div>

            <div v-if="initialPackageOrderData" class="col-md-3">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" v-model="isRemoved" disabled>
                <label class="form-check-label text-danger">Usunięte</label>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div v-if="doCreateProspect" class="card shadow-sm mb-4 border-info">
        <div class="card-header bg-info-subtle text-info-emphasis">
          <h6 class="mb-0 fw-bold"><i class="fas fa-file-contract me-2"></i>Ustawienia Prospektu</h6>
        </div>
        <div class="card-body">
          <div class="row g-3">

            <div class="col-md-6">
              <label class="form-label">Data wygaśnięcia</label>
              <input type="datetime-local" :class="prospectExpiryDateInputClass" v-model="prospectExpiryDateFormatted" :disabled="readOnly">
              <div class="invalid-feedback">Data wygaśnięcia prospektu jest wymagana</div>
            </div>
            <div
                 class="col-md-6">
              <label v-if="initialPackageOrderData" class="form-label">Data zamknięcia</label>
              <!--              Nie mozna edytować, zamknięcie będzie updatowana automatycznie po realnym zamknieciu prospektu przez system-->
              <input v-if="initialPackageOrderData" type="datetime-local" class="form-control" v-model="prospectCloseDateFormatted" :disabled="true">
            </div>

            <div class="col-md-4">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="prospectAllowModifyAmount" :disabled="readOnly">
                <label class="form-check-label">Zezwalaj na zmianę ilości</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="prospectAllowAddProducts" :disabled="readOnly">
                <label class="form-check-label">Zezwalaj na dodawanie produktów</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="prospectAllowPurchasePrice" :disabled="readOnly">
                <label class="form-check-label">Zezwalaj na widok cen zakupu</label>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div v-if="orderToDivide" class="card shadow-sm mb-4 border-warning">
        <div class="card-header bg-warning-subtle text-warning-emphasis">
          <h6 class="mb-0 fw-bold"><i class="fas fa-project-diagram me-2"></i>Konfiguracja Podziału</h6>
        </div>
        <div class="card-body">
          <div class="row g-3">

            <div class="col-md-6">
              <label class="form-label">Główna Apteka Dzieląca (Client ID)</label>
              <input
                  type="text"
                  :class="dividerMainDrugstoreInputClass"
                  v-model="dividerMainDrugstoreClientId"
                  :disabled="readOnly"
                  placeholder="Wpisz ID klienta apteki"
              >
              <div class="invalid-feedback">ID klienta apteki jest wymagane</div>

              <div v-if="dividerMainDrugstoreObject" class="form-text text-success mt-1">
                <i class="fas fa-check me-1"></i> Znaleziono: {{ dividerMainDrugstoreObject.name }}
              </div>
            </div>

            <div class="col-12">
              <label class="form-label">Lista aptek do podziału (numery)</label>
              <textarea
                  class="form-control"
                  v-model="dividerDrugstoresNumbersString"
                  :disabled="readOnly"
                  placeholder="Wpisz numery aptek oddzielone przecinkami (np. 1001, 1002)"
                  rows="2"
              ></textarea>
            </div>

          </div>
        </div>
      </div>

<!--      <div class="card shadow-sm mb-4">-->
<!--        <div class="card-body bg-light">-->
<!--          <div class="row g-2 small text-muted font-monospace">-->
<!--            <div class="col-md-4">Plik Excel: {{ orderExcelFileName || 'Brak' }}</div>-->
<!--            <div class="col-md-4">Data pliku: {{ formatDate(orderExcelFileDate) }}</div>-->
<!--            <div class="col-md-4">Metoda kalkulacji: {{ calculationMethodReference }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <div class="d-flex justify-content-end" v-if="showSaveButton && !readOnly">
        <button type="button" class="btn btn-primary px-4" @click="saveData">
          <i class="fas fa-save me-1"></i> {{ submitButtonText }}
        </button>
      </div>

    </form>


    <SupplierListModal
        v-if="modals.showSupplier"
        v-model:showModal="modals.showSupplier"
        :multiselect="false"
        okTitle="Wybierz dostawcę"
        @onApply="handleSupplierSelected"
        @onClose="modals.showSupplier = false"
        :showMassActions="false"
        :showAddButton="false"
        :showCheckboxColumn="false"
        :visibleColumnsFilter="['id', 'centralId','nip','name']"
    />

    <SupplierListModal
        v-if="modals.showWholesaler"
        v-model:showModal="modals.showWholesaler"
        :multiselect="false"
        okTitle="Wybierz hurtownika"
        @onApply="handleWholesalerSelected"
        @onClose="modals.showWholesaler = false"
        :showMassActions="false"
        :showAddButton="false"
        :showCheckboxColumn="false"
        :visibleColumnsFilter="['id', 'centralId','nip','name']"
    />

  </div>
</template>

<script>
import { useCommonAppModule } from "@/state/pinia/commonAppModule";
import { useLazyLoaderModule } from "@/state/pinia/lazyloaderManagerModule";
import { apiRequestsHelper } from "@/state/pinia/apiRequestHelper";
import dateFormat from "dateformat";
import SupplierListModal from "@/views/DrugstoreCommonManager/SupplierListModal.vue";
import {log} from "@/state/pinia/log";
import {usePackagesManagerModule} from "@/state/pinia/packagesManagerModule";

export default {
  name: "PackageOrderForm",
  components: {
    SupplierListModal
  },
  props: {
    initialPackageOrderData: {
      type: Object,
      required: false
    },
    submitButtonText: {
      type: String,
      default: "Zapisz"
    },
    showSaveButton: {
      type: Boolean,
      default: true
    },
    // Nowy prop do trybu tylko do odczytu
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // Oryginalne zmienne
      orderName: "",
      orderDate: null,
      orderToDivide: false,
      notifications: "",
      dividerMainDrugstoreObject: null,
      currentAssignedSupplierObject: null,
      currentAssignedWholesalerObject: null,

      // Zmienne z DTO (Rozszerzenie)
      orderReference: "",
      producer: "",
      orderStatus: null,
      orderValueTaxExcluded: 0,
      orderValueTaxIncluded: 0,
      orderUnitsAmount: 0,
      realisationLevel: 0,
      isRemoved: false,
      targetSupplyDays: 0,
      orderExcelFileName: "",
      orderExcelFileDate: null,
      calculationMethodReference: "",

      // Daty (formatowane do inputa)
      orderCreationDateFormatted: null,
      orderRealisationDateFormatted: null,

      // Prospekt
      doCreateProspect: false,
      prospectExpiryDateFormatted: null,
      prospectCloseDateFormatted: null,
      prospectAllowModifyAmount: false,
      prospectAllowAddProducts: false,
      prospectAllowPurchasePrice: false,

      // Podział
      dividerMainDrugstoreClientId: "",
      dividerDrugstoresNumbers: [], // Przechowuje listę numerów

      // Walidacja
      validation: {
        orderName: true,
        supplierId: true,
        wholesalerId: true,
        dividerMainDrugstore: true,
        prospectExpiryDate:true
      },

      modals: {
        showSupplier: false,
        showWholesaler: false
      }
    };
  },
  computed: {
    commonAppModule() {
      return useCommonAppModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
    packagesModule() {
      return usePackagesManagerModule();
    },

    // Oryginalne computed
    assignedSupplierValue() {
      if (this.currentAssignedSupplierObject) {
        return `${this.currentAssignedSupplierObject.id} - ${this.currentAssignedSupplierObject.name}`;
      }
      return "Nie przypisano";
    },

    assignedWholesalerValue() {
      if (this.currentAssignedWholesalerObject) {
        return `${this.currentAssignedWholesalerObject.id} - ${this.currentAssignedWholesalerObject.name}`;
      }
      return "Nie przypisano";
    },

    supplierIdInputClass() {
      if (this.validation.supplierId) {
        return "form-control";
      } else {
        return "form-control is-invalid";
      }
    },

    wholesalerIdInputClass() {
      if (this.validation.wholesalerId) {
        return "form-control";
      } else {
        return "form-control is-invalid";
      }
    },

    orderNameInputClass() {
      if (this.validation.orderName) {
        return "form-control";
      } else {
        return "form-control is-invalid";
      }
    },

    prospectExpiryDateInputClass() {
      if (this.validation.prospectExpiryDate) {
        return "form-control";
      } else {
        return "form-control is-invalid";
      }
    },

    dividerMainDrugstoreInputClass() {
      if (this.validation.dividerMainDrugstore) {
        return "form-control";
      } else {
        return "form-control is-invalid";
      }
    },

    orderIsCentral() {
      return (this.initialPackageOrderData && this.initialPackageOrderData.isCentral === true) || false;
    },

    // Pomocniczy computed do obsługi listy numerów aptek w textarea
    dividerDrugstoresNumbersString: {
      get() {
        if (Array.isArray(this.dividerDrugstoresNumbers)) {
          return this.dividerDrugstoresNumbers.join(", ");
        }
        return "";
      },
      set(val) {
        if (!val) {
          this.dividerDrugstoresNumbers = [];
        } else {
          this.dividerDrugstoresNumbers = val.split(",").map(s => s.trim()).filter(s => s.length > 0);
        }
      }
    }
  },
  watch: {
    initialPackageOrderData: {
      handler(newVal) {
        if (newVal) {
          // --- ORYGINALNA LOGIKA INICJALIZACJI ---
          this.orderName = newVal.orderName;

          if (newVal.orderCreationDate) {
            // Oryginalnie było przypisanie timestampa, teraz konwertuję do stringa dla inputa HTML5
            this.orderCreationDateFormatted = this.timestampToInput(newVal.orderCreationDate);
          }
          if (newVal.orderRealisationDate) {
            this.orderRealisationDateFormatted = this.timestampToInput(newVal.orderRealisationDate);
          }

          this.orderToDivide = newVal.toDivide;
          this.notifications = newVal.notifications || "";

          // Pobieranie dostawcy (bez zmian)
          const supplierGuid = newVal.centralSupplierGuid;
          if (supplierGuid) {
            this.lazyloaderModule.setDisplayLazyLoader(true);
            this.commonAppModule.httpGetSupplierByGuid({ guid: supplierGuid }).then((response) => {
              this.currentAssignedSupplierObject = response.data.payload;
              this.lazyloaderModule.setDisplayLazyLoader(false);
            });
          }

          const wholesalerGuid = newVal.wholesalerGuid;
          if (wholesalerGuid) {
            this.lazyloaderModule.setDisplayLazyLoader(true);
            this.commonAppModule.httpGetSupplierByGuid({ guid: wholesalerGuid }).then((response) => {
              this.currentAssignedWholesalerObject = response.data.payload;
              this.lazyloaderModule.setDisplayLazyLoader(false);
            });
          }

          // Pobieranie apteki dzielącej (bez zmian)
          if (this.orderToDivide) {
            // Tutaj update: pobieramy ID z DTO, bo oryginalnie było tylko w propsie
            this.dividerMainDrugstoreClientId = newVal.dividerMainDrugstoreClientId;

            if (this.dividerMainDrugstoreClientId) {
              this.lazyloaderModule.setDisplayLazyLoader(true);
              this.commonAppModule.httpGetDrugstoreByDrugstoreClientId({ drugstoreClientId: this.dividerMainDrugstoreClientId }).then((response) => {
                if (response.status === 200) {
                  this.dividerMainDrugstoreObject = response.data.payload;
                }
                apiRequestsHelper.handleResponseWithDialogs(response, false);
              }).catch((error) => {
                apiRequestsHelper.catchResponseError(error, "httpGetDrugstoreByDrugstoreClientId");
              }).finally(() => {
                this.lazyloaderModule.setDisplayLazyLoader(false);
              });
            }
          }

          // --- ROZSZERZENIE O NOWE POLA Z DTO ---
          this.orderReference = newVal.orderReference;
          this.producer = newVal.producer;
          this.orderStatus = newVal.orderStatus ? newVal.orderStatus.key : "CREATED";
          this.orderValueTaxExcluded = newVal.orderValueTaxExcluded;
          this.orderValueTaxIncluded = newVal.orderValueTaxIncluded;
          this.orderUnitsAmount = newVal.orderUnitsAmount;
          this.realisationLevel = newVal.realisationLevel;
          this.isRemoved = newVal.isRemoved;
          this.targetSupplyDays = newVal.targetSupplyDays;
          this.orderExcelFileName = newVal.orderExcelFileName;
          this.orderExcelFileDate = newVal.orderExcelFileDate;
          this.calculationMethodReference = newVal.calculationMethodReference;

          // Prospekt
          this.doCreateProspect = newVal.doCreateProspect;
          this.prospectExpiryDateFormatted = this.timestampToInput(newVal.prospectExpiryDate);
          this.prospectCloseDateFormatted = this.timestampToInput(newVal.prospectCloseDate);
          this.prospectAllowModifyAmount = newVal.prospectAllowModifyAmount;
          this.prospectAllowAddProducts = newVal.prospectAllowAddProducts;
          this.prospectAllowPurchasePrice = newVal.prospectAllowPurchasePrice;

          // Divider list
          if(newVal.dividerDrugstoresNumbers) {
            this.dividerDrugstoresNumbers = Array.from(newVal.dividerDrugstoresNumbers);
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // Helpery do formatowania
    timestampToInput(ts) {
      if (!ts) return null;
      return dateFormat(new Date(ts), "yyyy-mm-dd'T'HH:MM");
    },
    inputToTimestamp(dateStr) {
      if(!dateStr) return null;
      return new Date(dateStr).getTime();
    },
    formatDate(ts) {
      if (!ts) return "-";
      return dateFormat(new Date(ts), "yyyy-mm-dd HH:MM:ss");
    },

    // --- ORYGINALNE METODY ---

    openSupplierAssigningForm() {
      if (this.readOnly) return; // Zabezpieczenie
      this.modals.showSupplier = true;
    },

    openWholesalerAssigningForm() {
      if (this.readOnly) return; // Zabezpieczenie
      this.modals.showWholesaler = true;
    },

    handleSupplierSelected(selection) {
      const supplier = Array.isArray(selection) ? selection[0] : selection;
      if (supplier) {
        this.currentAssignedSupplierObject = supplier;
        this.modals.showSupplier = false;
        // Reset walidacji
        this.validation.supplierId = true;
      }
    },

    handleWholesalerSelected(selection) {
      const wholesaler = Array.isArray(selection) ? selection[0] : selection;
      if (wholesaler) {
        this.currentAssignedWholesalerObject = wholesaler;
        this.modals.showWholesaler = false;
        // Reset walidacji
        this.validation.wholesalerId = true;
      }
    },

    saveData() {
      if (this.readOnly) return;
      const isValid = this.validate();
      if (isValid) {
        return this.onApplyData();
      }
    },

    validate() {
      var isValid = true;
      var notValidFieldsCount = 0;
      this.validation.orderName = this.orderName && this.orderName.length > 0;
      if(!this.validation.orderName){
        notValidFieldsCount++;
      }

      this.validation.supplierId = !!this.currentAssignedSupplierObject;
      if(!this.validation.supplierId){
        notValidFieldsCount++;
      }

      this.validation.wholesalerId = !!this.currentAssignedWholesalerObject;
      if(!this.validation.wholesalerId){
        notValidFieldsCount++;
      }

      if (this.orderToDivide) {
        if (!this.dividerMainDrugstoreObject || Object.keys(this.dividerMainDrugstoreObject).length === 0) {
          this.validation.dividerMainDrugstore = false;
          notValidFieldsCount++;
        } else {
          this.validation.dividerMainDrugstore = true;
        }
      }

      if(this.doCreateProspect){
        if(!this.prospectExpiryDateFormatted){
          this.validation.prospectExpiryDate = false;
          notValidFieldsCount++;
        }else{
          this.validation.prospectExpiryDate = true;
        }
      }

      if (notValidFieldsCount > 0) {
        isValid = false;
      } else {
        isValid = true;
      }
      console.log("Form validation: " + (isValid ? "OK" : "NOT OK") + ", not valid fields: " + notValidFieldsCount + ".")
      return isValid;

    },

    onApplyData() {
      // Budujemy obiekt wynikowy na bazie oryginału + zmian z formularza
      if(!this.orderCreationDateFormatted){
        this.orderCreationDateFormatted = this.timestampToInput(new Date().getTime());
      }


      let res = {
        ...this.initialPackageOrderData,

        // Oryginalne pola
        orderName: this.orderName,
        notifications: this.notifications,
        toDivide: this.orderToDivide,

        // Zaktualizowane klucze obce
        centralSupplierGuid: this.currentAssignedSupplierObject ? this.currentAssignedSupplierObject.guid : null,
        wholesalerGuid: this.currentAssignedWholesalerObject ? this.currentAssignedWholesalerObject.guid : null,

        // --- NOWE POLA Z FORMULARZA (ROZSZERZENIE) ---
        orderReference: this.orderReference,
        producer: this.producer,
        targetSupplyDays: this.targetSupplyDays,

        // Daty - konwersja z powrotem na timestamp/long
        orderCreationDate: this.inputToTimestamp(this.orderCreationDateFormatted),
        orderRealisationDate: this.inputToTimestamp(this.orderRealisationDateFormatted),

        // Prospekt
        doCreateProspect: this.doCreateProspect,
        prospectExpiryDate: this.inputToTimestamp(this.prospectExpiryDateFormatted),
        prospectCloseDate: this.inputToTimestamp(this.prospectCloseDateFormatted),
        prospectAllowModifyAmount: this.prospectAllowModifyAmount,
        prospectAllowAddProducts: this.prospectAllowAddProducts,
        prospectAllowPurchasePrice: this.prospectAllowPurchasePrice,

        // Divider
        dividerMainDrugstoreClientId: this.dividerMainDrugstoreClientId,
        dividerDrugstoresNumbers: this.dividerDrugstoresNumbers
      };

      this.$emit("onApplyData", res);
      return res;
    }
  },
  created() {
    // logic of initial data was moved to watcher

  }
};
</script>

<style scoped>
.package-order-form {
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 0.9rem;
}

.required:after {
  content: " *";
  color: red;
}

.card-header {
  border-bottom: 1px solid rgba(0,0,0,0.05);
}

/* Dostosowanie wyglądu zablokowanych pól */
.form-control:disabled, .form-select:disabled, .form-check-input:disabled {
  background-color: #f8f9fa; /* Jasnoszary tło */
  opacity: 0.8;
  cursor: not-allowed;
}

/* Pola tylko do odczytu (statystyki) */
input[readonly] {
  background-color: #f8f9fa;
  border-color: #dee2e6;
}

/* Styl dla inputa dostawcy zależny od walidacji (zachowany z oryginału, zaadaptowany do klasy) */
.is-valid {
  border-color: #198754;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.is-invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
</style>
